import React from "react";
import styled from "styled-components";
import { TopSection } from "./topSection";
import { ServicesSection } from "./servicesSection"; // Zostawiamy tylko to
import { Marginer } from "../../components/navbar/marginer";
import { MoreAboutSection } from "./moreAboutSection";
import { Footer } from "../../components/footer";

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export function Homepage(props) {
  return (
    <PageContainer>
      <TopSection />
      <ServicesSection />
      {/* Usunęliśmy stąd ReviewsSection i Marginer */}
      <MoreAboutSection />
      <Marginer direction="vertical" margin="8em" />
      <Footer />
    </PageContainer>
  );
}
